import { render } from "./PackageEdit.vue?vue&type=template&id=675f34b6&scoped=true"
import script from "./PackageEdit.vue?vue&type=script&lang=js"
export * from "./PackageEdit.vue?vue&type=script&lang=js"

import "./PackageEdit.vue?vue&type=style&index=0&id=675f34b6&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675f34b6"]])

export default __exports__